import React from 'react'

import lang from '@/lang'

import SelectInput from '../../../base/components/inputs/select-input/select-input'
import TodoIntervalEnum from '@/enums/todoInterval.enum'

const intervalOptions = [
  { value: TodoIntervalEnum.SINGLE, label: lang.todo.intervals[TodoIntervalEnum.SINGLE] },
  { value: TodoIntervalEnum.DAILY, label: lang.todo.intervals[TodoIntervalEnum.DAILY] },
  { value: TodoIntervalEnum.WEEKLY, label: lang.todo.intervals[TodoIntervalEnum.WEEKLY] },
  { value: TodoIntervalEnum.MONTHLY, label: lang.todo.intervals[TodoIntervalEnum.MONTHLY] },
  { value: TodoIntervalEnum.QUARTERLY, label: lang.todo.intervals[TodoIntervalEnum.QUARTERLY] },
  { value: TodoIntervalEnum.YEARLY, label: lang.todo.intervals[TodoIntervalEnum.YEARLY] },
]

export function IntervalSelect(props) {
  const { onChange, ...restProps } = props

  const options = {
    infiniteScroll: true,
    allowCreate: false,
    customSelectOptions: {
      isClearable: false,
      escapeClearValue: true,
      hideSelectedOptions: false,
      placeholder: lang.selectInput.interval,
      defaultMenuIsOpen: false,
      defaultOptions: true,
    },
    useFormik: false,
    options: intervalOptions,
  }

  const handleIntervalChange = (option) => {
    onChange && onChange(option)
  }

  return (
    <>
      <SelectInput
        {...restProps}
        {...options}
        handleChange={handleIntervalChange}
      />
    </>
  )
}
